import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { saveToken, saveUser } from '../../services/auth';
import Toast from '../../components/common/Toast';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [showPassword, setShowPassword] = useState(false);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log('🔐 Attempting login...', { email: formData.email });

    try {
      const response = await authAPI.login(formData.email, formData.password);

      console.log('📡 Full response:', response);
      console.log('📦 Response data:', response.data);
      console.log('✅ Success:', response.data.success);

      if (response.data && response.data.success) {
        const { access_token, refresh_token, admin } = response.data.data;

        console.log('🎫 Tokens received:', {
          hasAccessToken: !!access_token,
          hasRefreshToken: !!refresh_token,
          admin: admin
        });

        // Save tokens and user data
        saveToken(access_token);
        saveUser(admin);

        console.log('💾 Tokens saved to localStorage');

        setToast({
          show: true,
          message: 'Login successful! Redirecting...',
          type: 'success',
        });

        setTimeout(() => {
          console.log('🚀 Navigating to dashboard...');
          navigate('/');
        }, 1000);
      } else {
        console.error('❌ Response success is false or missing');
        throw new Error(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      console.error('❌ Error response:', error.response);

      setToast({
        show: true,
        message: error.response?.data?.message || error.message || 'Invalid email or password',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className="login-card">
        <div className="login-logo">
          <img
            src="/logo.svg"
            alt="Nisa Care Logo"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: 'var(--radius-md)'
            }}
          />
        </div>
        <p className="login-subtitle">Sign in to your account</p>

        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <div className="mb-3">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="admin@nisa-care.com"
              value={formData.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>

          {/* Password Field with Eye Toggle */}
          <div className="mb-4 position-relative">
            <label className="form-label">Password</label>
            <div className="input-group border rounded shadow-sm">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control border-0" 
                name="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
                style={{ boxShadow: 'none' }} 
              />
              <button
                className="btn border-0 bg-transparent" 
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{ boxShadow: 'none' }} 
              >
                <i className={`bi bi-eye${showPassword ? '-slash' : ''} text-muted`}></i>
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="btn btn-primary d-flex align-items-center justify-content-center w-100 py-2"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                <span>Signing in...</span>
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2"></i>
                <span>Sign In</span>
              </>
            )}
          </button>
        </form>


        <div className="text-center mt-4">
          <small className="text-muted">
            Default: admin@nisa-care.com / Admin@123
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;